import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../i18n/constants/keys';
import { getOverviewDetails } from '../../../../../../utils/api_service/SmartInterview';
import { UpcommingInterviews } from './Components';
import PieChart from './Components/Chart';

interface ChartItem {
  label: string;
  value: number;
}

interface UpcomingInterview {
  user: {
    firstName: string;
    lastName: string;
    email: string;
  };
  interviewStartTime: number;
}

interface OverviewData {
  interviewTypeChart: ChartItem[];
  interviewApplicantStatusChart: ChartItem[];
  statusChart: ChartItem[];
  upcomingInterview: UpcomingInterview[];
}

interface OverviewProps {
  interviewRoundId?: string;
}

export const Overview: React.FC<OverviewProps> = ({ interviewRoundId }) => {
  const { t } = useTranslation(NS.adminPages);
  const SI = ADMIN_PAGES_KEYS.jobOpenings.smartInterviews;
  const [overviewData, setOverviewData] = useState<OverviewData | null>(null);

  const fetchOverviewDetails = async () => {
    if (!interviewRoundId) return;
    try {
      const response = await getOverviewDetails(interviewRoundId);
      const data = await response.json();
      setOverviewData(data);
    } catch {
      setOverviewData(null);
    }
  };

  useEffect(() => {
    fetchOverviewDetails();
  }, [interviewRoundId]);

  if (!overviewData) {
    return (
      <div className='flex min-h-[180px] items-center justify-center rounded-lg border border-slate-100 bg-white text-sm text-slate-500'>
        { t(SI.loading.overview) }
      </div>
    );
  }

  return (
    <div className='space-y-4'>
      <div className='grid w-full grid-cols-1 gap-3 md:grid-cols-3'>
        <div className='w-full min-w-0'>
          <PieChart
              data={overviewData.interviewApplicantStatusChart}
              title={t(SI.overview.interviewApplicantStatus)}
          />
        </div>
        <div className='w-full min-w-0'>
          <PieChart
              data={overviewData.interviewTypeChart}
              title={t(SI.overview.interviewTypes)}
          />
        </div>
        <div className='w-full min-w-0'>
          <PieChart data={overviewData.statusChart} title={t(SI.overview.interviewStatus)} />
        </div>
      </div>

      <UpcommingInterviews interviews={overviewData.upcomingInterview} />
    </div>
  );
};
